import './record-edit-menu.scss'

import { defineComponent } from 'vue'
import _ from 'lodash'
import { faCheck, faTabletAlt, faTimes, faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons'

import { RecordLifecycleState } from '@skinsoft/types'
import { recordSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { SAVE_CURRENT_RECORD_TOPIC } from '../../../../busTopics'
import { TRANSITION_RECORD_TO_STATE } from '../../../../events/events'
import { TransitionRecordToStateEvent } from '../../../../events/types'
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics'
import { getAppLocaleFromI18nLocale } from '@skinsoft/utils'

export const RecordEditMenu = defineComponent({
    mixins: [reactiveVueMixin],
    components: {

    },
    props: [''],
    template: require('./record-edit-menu.html'),
    data() {
        return {
            showValidation: false,
            recordId: "",
            onLine: false,
            hasCachedUpdates: false,
            running: false,
            states: ['inProgress', 'toValidated', 'validated'],

            selectedLifecycleState: null as any as RecordLifecycleState,

            displayStatuses: false,

            // Icons
            checkIcon: faCheck,
            crossIcon: faTimes,
            warningIcon: faTabletAlt,
            caretDownIcon: faCaretDown,
            caretRightIcon: faCaretRight,

            recordState: "",
        }
    },
    computed: {
        displayLocalWarning(): boolean {
            return !this.onLine || this.hasCachedUpdates
        },
    },
    mounted() {
        this.recordId = _.get(this.$route, 'params.recordId') as string
        this.subscribeTo(
            this.$recordDataStore.fetchOne(this.recordId),
            record => {
                this.recordState = recordSelectors.currentState(record, this.getAppLocale()) || ""
                this.unsubscribeFrom('record-subscription');
            },
            'record-subscription')
        this.$recordDataStore.hasCachedUpdates(this.recordId).then((res: boolean) => {
            this.hasCachedUpdates = res
        })
    },
    created() {
        this.running = true;
        this.onFrame();
    },
    beforeUnmount() {
        this.running = false;
    },
    methods: {
        saveRecord() {
            this.emitOnBus(SAVE_CURRENT_RECORD_TOPIC)
            this.emitOnBus(TOGGLE_MENU_TOPIC);
        },

        shouldDisplayStateEntry(key: string) {
            return key !== this.recordState;
        },

        onFrame() {
            this.onLine = window.navigator.onLine;
            if (this.running) {
                requestAnimationFrame(this.onFrame);
            }
        },

        onStatusClick(state: RecordLifecycleState) {
            this.showValidation = true;
            this.selectedLifecycleState = state;
        },

        transitionRecordToState() {
            const stateTranslations = this.getStateTranslations(this.selectedLifecycleState)
            this.emitOnBus(TRANSITION_RECORD_TO_STATE, {
                state: this.selectedLifecycleState,
                translations: stateTranslations,
            } as TransitionRecordToStateEvent)
        },

        getStateTranslations(state: string): {[key: string]: string} {
            let res = {}
            for(const locale of this.$i18n.availableLocales) {
                const stateName: string = this.$t(`state.${state}`, locale) as string
                const appLocale = getAppLocaleFromI18nLocale(locale) ?? locale

                if(stateName) {
                    _.set(
                        res,
                        appLocale,
                        stateName
                    )
                }
            }

            return res
        },

        resetValidation() {
            this.selectedLifecycleState = null as any;
            this.showValidation = false;
        },
    },
})
